/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataManualInfoUserResVo
 */
export interface NodataManualInfoUserResVo {
    /**
     * 会员编号，用于补登表单自动回填。
     * 会员编号
     * @type {string}
     * @memberof NodataManualInfoUserResVo
     */
    userCode?: string;
    /**
     * 订单业务编号，用于补登表单展示和回填。
     * 订单编号
     * @type {string}
     * @memberof NodataManualInfoUserResVo
     */
    orderCode?: string;
}

/**
 * Check if a given object implements the NodataManualInfoUserResVo interface.
 */
export function instanceOfNodataManualInfoUserResVo(value: object): value is NodataManualInfoUserResVo {
    return true;
}

export function NodataManualInfoUserResVoFromJSON(json: any): NodataManualInfoUserResVo {
    return NodataManualInfoUserResVoFromJSONTyped(json, false);
}

export function NodataManualInfoUserResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataManualInfoUserResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
    };
}

export function NodataManualInfoUserResVoToJSON(json: any): NodataManualInfoUserResVo {
    return NodataManualInfoUserResVoToJSONTyped(json, false);
}

export function NodataManualInfoUserResVoToJSONTyped(value?: NodataManualInfoUserResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userCode': value['userCode'],
        'orderCode': value['orderCode'],
    };
}

